// extracted by mini-css-extract-plugin
export default {"container":"LpDifficultyLevelIndicator_container__50uP2","flagIcon":"LpDifficultyLevelIndicator_flagIcon__4kRpg"};